import { defineMessages } from "react-intl";
const messages = defineMessages({
    downloadCsvTitle: {
        id: "app.analytics.download.csv.title",
        defaultMessage: "Download .CSV",
    },
    downloadAnalyticslert: {
        id: "app.analytics.download.analytics.alert",
        defaultMessage: "Downloading analytics data...",
    },
    dateRangeTitle: {
        id: "app.analytics.date.range.title",
        defaultMessage: "Date Range",
    },
    conversionTitle: {
        id: "app.analytics.conversion.data.title",
        defaultMessage: "Conversion",
    },
    sgtEngagementTitle: {
        id: "app.analytics.sgt.engagement.title",
        defaultMessage: "Self-Guided Tours Engagement",
    },
    virtualTourEngagementTitle: {
        id: "app.analytics.virtual.tour.engagement.title",
        defaultMessage: "Virtual Tour Engagement",
    },
    floorplanViewsTitle: {
        id: "app.analytics.floorplan.views.title",
        defaultMessage: "Floorplan Views",
    },
    layoutViewsTitle: {
        id: "app.analytics.layout.views.title",
        defaultMessage: "Layout Views",
    },
    amenityViewsTitle: {
        id: "app.analytics.amenity.views.title",
        defaultMessage: "Amenity Views",
    },
    referralSourcesTitle: {
        id: "app.analytics.referral.sources.title",
        defaultMessage: "Referral Sources",
    },
    contentCreationTitle: {
        id: "app.analytics.content.creation.title",
        defaultMessage: "Content Creation",
    },
    detailsTableLabel: {
        id: "app.analytics.details.table.label",
        defaultMessage: "Details Table",
    },
    downloadButtonLabel: {
        id: "app.analytics.download.button.label",
        defaultMessage: "Download Selection",
    },
    communitiesTitle: {
        id: "app.analytics.download.communities.title",
        defaultMessage: "Communities",
    },
    allProspectsMessage: {
        id: "app.analytics.all.prospects.message",
        defaultMessage: "All Prospects",
    },
    prospectsStatusTitle: {
        id: "app.analytics.prospects.status.title",
        defaultMessage: "Prospects Status:",
    },
    downloadTimeDisclaimer: {
        id: "app.analytics.download.time.disclaimer",
        defaultMessage: "Downloads may take up to 4 minutes. Please stay on this page to avoid interruptions.",
    },
    downloading: {
        id: "app.analytics.downloading",
        defaultMessage: "Downloading...",
    },
    downloadFailed: {
        id: "app.analytics.download.failed",
        defaultMessage: "Download Failed",
    },
});
export default messages;
